<template>
  <iframe
    id="simulation-report"
    :src="simulationReportUrl"
    style="width: 100%; border: 1px solid #fff"
    :style="{ height: pageHeight }"
  ></iframe>
</template>

<script>
import { mapState } from 'vuex';
export default {
  name: 'simulation-report',
  data() {
    return {
      windowHeight: 0,
    };
  },

  methods: {},
  computed: {
    ...mapState({
      simulationReportUrl: (state) => state.Reports.simulationReportUrl,
    }),
    pageHeight() {
      return `${this.windowHeight}px`;
    },
  },
  beforeRouteEnter(to, from, next) {
    document.title = to.meta.title;
    next();
  },
  mounted() {
    this.windowHeight = window.innerHeight;
    this.$nextTick(() => {
      window.addEventListener('resize', () => {
        this.windowHeight = window.innerHeight;
      });
    });
  },
};
</script>
